export default class MapConfig {
  /**
   * @param id {number|null}
   * @param name {String}
   * @param picture {String}
   * @param center {[number]}
   * @param pictureSize {[number]}
   */
  constructor ({ id = null, name, picture, center = [0, 0], pictureSize = [0, 0] }) {
    this.id = id
    this.name = name
    this.picture = picture
    this.pictureSize = pictureSize
    this.center = center
  }

  /**
   * @returns {String} Path to map picture, to use as image source
   */
  getPicturePath () {
    if (/^data:image\//.test(this.picture)) return this.picture
    else return `./${this.picture}`
  }

  isOSM () {
    return (!this.picture)
  }
}
